import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";
import { HomeRankingTabEnum } from "@enums";

type Response = components["schemas"]["HotDataModel"];

export type WhatsHotItem = components["schemas"]["ExtendedHotDataItem"];

export interface HomeWhatsHotData {
    [HomeRankingTabEnum.WHATS_TOP]: WhatsHotItem[];
    [HomeRankingTabEnum.WHATS_GROWING]: WhatsHotItem[];
}

const REQUEST_TYPE: keyof typeof apiConfig = 'get home whats hot data';

const transformData = (data: Response = {}): HomeWhatsHotData => ({
    [HomeRankingTabEnum.WHATS_TOP]: data.whatsTop ?? [],
    [HomeRankingTabEnum.WHATS_GROWING]: data.whatsGrowing ?? []
});

async function getHomeWhatsHotData(): Promise<HomeWhatsHotData> {
    try {
        const response: Response = await http.get(REQUEST_TYPE);

        return transformData(response);
    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return transformData();
    }
}

export function useHomeWhatsHotData() {
    return useData(transformData(), getHomeWhatsHotData);
}